import axios from 'axios'

export default  {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    // create({commit}, lineData) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .post(`/projects/billings/${lineData.billing_id}/lines`, lineData)
    //       .then(res => {
    //         resolve(res)
    //       })
    //       .catch(error => {
    //         reject(error)
    //       })
    //   })
    // },
  },

  getters: {},
}
